import { message } from 'antd';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const allowMethod: string[] = ['get', 'post', 'put', 'patch', 'delete'];
let isUnauthorizedErrorHandled = false;
// Axios 인스턴스 생성
const baseURL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://api.wereward.kr' // 상용 환경에서 사용할 URL
    : 'https://api.wepickofferwall.kr'; // 개발 환경에서 사용할 URL

const instance = axios.create({
  baseURL,
  timeout: 50000,
});

type Headers = {
  Accept: string;
  'Content-Type'?: string;
  Authorization?: string;
  'x-origin-verify'?: string,
};

interface AxiosRequest {
  requestAxios: <T>(method: string, url: string, data?: object) => Promise<T>;
}

const axiosRequest: AxiosRequest = {
  requestAxios: async <T>(method: string, url: string, data = {}) => {
    if (!allowMethod.includes(method.toLowerCase())) throw new Error('허용되지 않은 호출 method입니다.');
    const token = sessionStorage.getItem('token');

    // 요청이 시작될 때마다 플래그 초기화
    isUnauthorizedErrorHandled = false;

    try {
      let headers: Headers;
      headers = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'x-origin-verify': 'e721e00b-dc9f-4405-b2c7-7853c67d2d86',
      };

      if (data instanceof FormData) {
        headers = {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
          'x-origin-verify': 'e721e00b-dc9f-4405-b2c7-7853c67d2d86',
        };
      }

      const response = await instance({
        method,
        url: `${instance.defaults.baseURL}${url}`,
        data,
        headers,
      });

      return response as T;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.detail || ''; // 서버에서 반환하는 에러 메시지 필드 확인

        if (statusCode === 401) {
          if (!isUnauthorizedErrorHandled) {
            isUnauthorizedErrorHandled = true; // 플래그 설정
            if (errorMessage === 'Invalid email or password') {
              message.error('이메일 또는 비밀번호가 잘못되었습니다.');
            } else if (errorMessage === 'User status is not activated') {
              message.error('승인되지 않은 ID입니다. 관리자에게 문의해주세요.');
            } else {
              sessionStorage.removeItem('token');
              sessionStorage.removeItem('recoil-persist');
              sessionStorage.removeItem('advertiserKey');
              message.error('세션이 만료되었습니다. 다시 로그인해주세요.');
              setTimeout(() => {
                window.location.href = '/';
              }, 1500);
            }
          }
        } else {
          // 다른 HTTP 에러 상태 코드 처리
          // message.error('오류가 발생했습니다. 다시 시도해주세요.');
        }
      } else {
        message.error('오류가 발생했습니다. 다시 시도해주세요.');
      }
      throw error;
    }
  },
};

export default axiosRequest;
